module.exports = __webpack_public_path__ + "img/search-result.c674072.png";